import Vue from 'vue'
import Vuex from 'vuex'
import * as mutationTypes from './mutation-types'
import ApiClient from '../utils/api-client'
import ApiClientGo from '../utils/api-client-go'
import SessionManager from '@/utils/session-manager'

Vue.use(Vuex)
/* eslint-disable */
export default new Vuex.Store({
  // Need to see how to get env vars here.
  // strict: process.env.NODE_ENV !== 'production',
  state: {
    isLoggedIn: SessionManager.getAuthToken() != null && SessionManager.getAuthToken() != undefined,
    currentUser: SessionManager.getCurrentUser(),
    isLoading: false
  },
  actions: {
    login({commit, dispatch}, {email, password, keepLogged}) {
      commit(mutationTypes.START_LOADING)
      return ApiClientGo.sign_in({email, password})
        .then(response => {
          SessionManager.setLoggedIn({token: response.data.Authorization, keepLogged})
          commit(mutationTypes.LOGIN)
          return dispatch('updateUser')
        })
        .then(() => commit(mutationTypes.STOP_LOADING))
        .catch(error => {
          commit(mutationTypes.STOP_LOADING)
          throw error
        })
    },
    loginPreview({commit, dispatch}, {email, password, keepLogged}) {
      commit(mutationTypes.START_LOADING)
      return ApiClient.post('sign_in_preview', {data: {email: email, password: password}})
        .then(response => {
          SessionManager.setLoggedIn({token: response.headers.authorization, keepLogged: keepLogged})
          commit(mutationTypes.LOGIN)
          return dispatch('updateUser')
        })
        .then(() => commit(mutationTypes.STOP_LOADING))
        .catch(error => {
          commit(mutationTypes.STOP_LOADING)
          throw error
        })
    },
    loginWithToken({commit, dispatch}, {token}) {
      SessionManager.setLoggedIn({token: token, user: {}, keepLogged: false})
      commit(mutationTypes.LOGIN)
      return dispatch('updateUser')
    },
    updateUser({commit}) {
      // commit(mutationTypes.START_LOADING)


      return ApiClient.getUser()
        .then(user => {
          SessionManager.updateCurrentUser(user)
          commit(mutationTypes.UPDATE_USER, user)
          // commit(mutationTypes.STOP_LOADING)
        })
        .catch(error => {
          // commit(mutationTypes.STOP_LOADING)
          throw error
        })
    },
    logout({commit}) {
      SessionManager.setLoggedOut()
      commit(mutationTypes.LOGOUT)
    },
    signup({commit, dispatch}, {name, email, password, CodigoConvidado}) {
      commit(mutationTypes.START_LOADING)
      return ApiClientGo.sign_up({name, email, password, CodigoConvidado})
        .then(() => dispatch('login', {email, password, keepLogged: false}))
        .then(() => commit(mutationTypes.STOP_LOADING))
        .catch(error => {
          commit(mutationTypes.STOP_LOADING)
          throw error
        })
    },
    signup_lead({commit, dispatch}, {name, email, password, tipo}) {
      commit(mutationTypes.START_LOADING)
      return ApiClientGo.sign_up({name, email, password, CodigoConvidado, tipo})
        .then(() => dispatch('login', {email, password, keepLogged: false}))
        .then(() => commit(mutationTypes.STOP_LOADING))
        .catch(error => {
          commit(mutationTypes.STOP_LOADING)
          throw error
        })
    },
    socialNetworkLogin({commit, dispatch}, {provider, receivedData, errorMessage}) {
      commit(mutationTypes.START_LOADING)
      return ApiClientGo.get(`oauth/${provider}/callback/${receivedData}`)
        .then(response => {
          const Authorization = response.data.Authorization
          SessionManager.setLoggedIn({token: Authorization})
          commit(mutationTypes.LOGIN)
          return null
        })
        .then(() => document.location.reload(true))
        .catch(error => {
          errorMessage("Usuário ainda não registrado.")
          commit(mutationTypes.STOP_LOADING)
          throw error
        })
    },
  },
  mutations: {
    [mutationTypes.LOGIN](state) {
      state.isLoggedIn = true
    },
    [mutationTypes.UPDATE_USER](state, user) {
      state.currentUser = user
    },
    [mutationTypes.LOGOUT](state) {
      state.isLoggedIn = false
      state.currentUser = null
    },
    [mutationTypes.START_LOADING](state) {
      state.isLoading = true
    },
    [mutationTypes.STOP_LOADING](state) {
      state.isLoading = false
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js